
import { useLanguage } from "@/contexts/LanguageContext";
import { Link } from "react-router-dom";

export default function DesktopNavigation() {
  const { t, language } = useLanguage();
  
  // Use short Georgian text for desktop navigation
  const isGeorgian = language === 'ka';
  
  return (
    <nav className="flex items-center space-x-2 md:space-x-3 lg:space-x-6 backdrop-blur-[30%]">
      <Link to="/" className="text-sm font-medium transition-colors hover:text-primary whitespace-nowrap">
        {t("nav.home")}
      </Link>
      <Link to="/find-places" className="text-sm font-medium transition-colors hover:text-primary whitespace-nowrap">
        {isGeorgian ? t("nav.findPlacesShort") : t("nav.findPlaces")}
      </Link>
      <Link to="/rate-place" className="text-sm font-medium transition-colors hover:text-primary whitespace-nowrap">
        {isGeorgian ? t("nav.ratePlaceShort") : t("nav.ratePlace")}
      </Link>
    </nav>
  );
}
